import { apiRegistry } from '../../../common/infra/apiRegistry'
import { favoritesMem } from '../mem/favoritesMem'

apiRegistry.registerGetApi('getFavorites', async () => {
  return { favorites: Object.values(favoritesMem) }
})
